import { Droplets, Sun, Snowflake, Sparkles, MoonStar, Heart } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const BENEFITS = [
  { icon: Droplets, title: "Hydrates", copy: "Hydrogel serum helps the delicate under-eye area feel deeply hydrated." },
  { icon: Sun, title: "Refreshes", copy: "Helps skin feel awake and refreshed, morning or night." },
  { icon: Snowflake, title: "Cools", copy: "A soothing, cooling hydrogel sensation — lovely straight from the fridge." },
  { icon: Sparkles, title: "Effortless", copy: "An easy at-home ritual: apply, relax, remove. No mess, no fuss." },
  { icon: MoonStar, title: "Self-Care", copy: "Perfect for slow mornings or an evening wind-down moment." },
  { icon: Heart, title: "Gentle", copy: "Kind to the delicate under-eye area — gentle enough for everyday use." },
];

export const Benefits = () => (
  <section id="benefits" className="py-24 md:py-32" data-testid="benefits-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        eyebrow="Why You'll Love Them"
        title={<>A small ritual with a <span className="italic gold-text">golden</span> touch</>}
        copy="Six simple reasons these hydrogel patches earn a permanent place on your shelf."
      />
      <div className="mt-16 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.07}>
            <div
              data-testid={`benefit-card-${b.title.toLowerCase()}`}
              className="group h-full rounded-2xl border border-champagne/70 bg-white p-6 md:p-7 transition-[box-shadow,transform] duration-500 hover:shadow-[0_16px_40px_rgb(201,162,39,0.10)] hover:-translate-y-1"
            >
              <b.icon size={30} strokeWidth={1} className="text-gold-deep transition-transform duration-500 group-hover:scale-110" />
              <h3 className="mt-5 font-display text-xl md:text-2xl text-ink">{b.title}</h3>
              <p className="mt-2.5 text-sm text-[#5C5C5C] leading-relaxed">{b.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
